import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ChartsV4 from '../../services/charts';

export default function AmPieChart(props) {
  const { chartId, containerClass, stats, options, type } = props;
  const chart = useRef(null);

  useEffect(() => {
    ChartsV4.ready(() => {
      if (type === 'donutWithLabel') {
        chart.current = ChartsV4.donutWithLabel(stats, chartId, options);
      } else {
        chart.current = ChartsV4.pie(stats, chartId, options);
      }
    });

    return () => {
      if (chart.current) {
        chart.current.dispose();
      }
    };
  });

  return <div className={containerClass} id={chartId} />;
}

AmPieChart.propTypes = {
  containerClass: PropTypes.string,
  chartId: PropTypes.string.isRequired,
  stats: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  options: PropTypes.shape({
    category: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    customLabel: PropTypes.string,
    groupThreshold: PropTypes.number,
  }).isRequired,
  type: PropTypes.string,
};

AmPieChart.defaultProps = {
  containerClass: '',
  type: '',
};
